import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@pella/sash-framework';
import { Image, CTA } from '../../../';

import styles from './index.module.scss';

export default function LimitedWarrantyV2({ data }) {
	const image = data.image?.[0] || data.gatsby_image?.[0];

	return (
		<Container className='my-10'>
			<div className={`${styles.limitedWarranty} flex flex-wrap items-center`}>
				<div className='flex-1 px-6 py-5 md:px-10 md:py-8'>
					{data.heading && <p className='text-h2'>{data.heading}</p>}
					{data.description && (
						<div
							dangerouslySetInnerHTML={{ __html: data.description }}
							className='mt-2 text-subtitle'
						/>
					)}
					{data.ctas?.[0] && (
						<CTA
							data={data.ctas[0]}
							className='mt-4 md:mt-6'
						/>
					)}
				</div>

				{image && (
					<div className='hidden h-full w-full md:block md:flex-1'>
						<Image
							data={image}
							className='block h-full w-full'
						/>
					</div>
				)}
			</div>
		</Container>
	);
}

LimitedWarrantyV2.propTypes = {
	data: PropTypes.object,
};
